<template>
	<div class="protocol-wrap">
        <h1>订单协议</h1>
		<div class="protocol-content">
            <div class="text-wrap">
                <p>1、处理期间，请拉黑或不与消费者联系、不对评价回复或解释（已回复的不影响处理）；</p>
                <p>2、处理周期为五天，期限内撤单须扣除该订单付款金额50%违约金，五天期限后可正常申请退款 ；</p>
                <p>3、五天处理期限内，不自行或交由他人处理，期限内解决的订单，都代表任务完成，应当收取费用 。</p> 
            </div>
            <slot></slot>
        </div>
	</div>
</template>

<script>
export default {
    data() {
    	return {
			
		};
    },
  
    methods:{
        
    },
};
</script>

<style lang="scss" scoped>
	.protocol-wrap{
        h1{
            font-size: 20px;
            @include font-style;
            color: #000000;
            margin-top: 20px;
        }
        .protocol-content{
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            // width: 510px;
            height: 685px;
            margin-top: 20px;
            box-sizing: border-box;
            padding: 30px;
            background: #FFFFFF;
            box-shadow: 1px 3px 6px 0px rgba(102, 102, 102, 0.16);
            .text-wrap{
                p{
                    font-size: 16px;
                    @include font-style;
                    color: #343434;
                    margin-bottom: 30px;
                }
            }
            
        }
    }
	
</style>